import { render, staticRenderFns } from "./cDataCaptureQuestionnaire.vue?vue&type=template&id=30fd3788&scoped=true"
import script from "./cDataCaptureQuestionnaire.vue?vue&type=script&lang=js"
export * from "./cDataCaptureQuestionnaire.vue?vue&type=script&lang=js"
import style0 from "./cDataCaptureQuestionnaire.vue?vue&type=style&index=0&id=30fd3788&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fd3788",
  null
  
)

export default component.exports